import React from 'react';

import { Text } from '@wix/wix-ui-tpa/cssVars';

import { st, classes } from './DateDivider.st.css';

export const DateDivider: React.FC<{
  label: string;
  createdDate?: number;
}> = ({ label, createdDate }) => {
  return (
    <div className={st(classes.root)} role="separator" aria-label={label}>
      <time
        dateTime={createdDate ? new Date(createdDate).toISOString() : undefined}
      >
        <Text className={st(classes.label)}>{label}</Text>
      </time>
    </div>
  );
};
